var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skipped-btn-container",attrs:{"role":"button"},on:{"click":_vm.onClick}},[_c('AppTextTooltip',{attrs:{"tooltipText":_vm.tooltipText}},[_c('SIcon',{attrs:{"name":"skipped-block"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }